import { Component, Input, Signal, signal, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { StartPageSearchResults } from '../../interfaces/start-page-search-results.interface';
import { SearchResultsService } from 'src/app/pages/start-page/services/search-results.service';
import { StartPageResultComponent } from './components/start-page-result/start-page-result.component';
import { AppFinderResultComponent } from './components/app-finder-result/app-finder-result.component';
import { NavigationSetup } from '../../services/navigation-items-service/navigation-setup';
import { PlatformService } from '../../services/platform-service/platform.service';
import { AppButtonComponent } from '../app-button/app-button.component';
import { ButtonTypeEnum } from '../../enums/buttonType.enum';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'search-result',
  imports: [
    CommonModule,
    StartPageResultComponent,
    AppFinderResultComponent,
    RouterLink,
    AppButtonComponent,
    TranslatePipe,
  ],
  templateUrl: './search-result.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./search-result.component.scss'],
})
export class SearchResultComponent {
  @Input() searchResults: Signal<StartPageSearchResults> = signal({
    appFinder: [],
    collectionFinder: [],
    startPage: [],
  });

  @Input() openSearchResult: boolean | number = false;

  protected link = NavigationSetup.APP_FINDER.routerLink;
  protected ButtonTypeEnum = ButtonTypeEnum;

  constructor(
    protected searchResultsService: SearchResultsService,
    protected platformService: PlatformService,
  ) {}

  closeSearchResults(): void {
    this.searchResultsService.isSearchResultVisible.next(false);
    this.searchResultsService.shouldOpenSearch.next(false);
    this.openSearchResult = false;
  }

  showSearchResult(): boolean {
    if (typeof this.openSearchResult === 'boolean') {
      return this.openSearchResult;
    } else {
      return this.openSearchResult > 2;
    }
  }

  hasAnyResults(): boolean {
    const r = this.searchResults();
    return !!(r.startPage.length || r.appFinder.length || r.collectionFinder.length);
  }

  onResultsScroll(): void {
    if (!this.platformService.isMobile()) {
      return;
    }

    const active = document.activeElement as HTMLElement | null;
    if (!active) return;

    const tag = active.tagName.toLowerCase();
    const isTextInput =
      tag === 'input' || tag === 'textarea' || active.hasAttribute('contenteditable');

    if (isTextInput) {
      active.blur();
    }
  }

  onResultsTouchStart(_event: TouchEvent): void {
    if (!this.platformService.isMobile()) {
      return;
    }

    const active = document.activeElement as HTMLElement | null;
    if (!active) return;

    const tag = active.tagName.toLowerCase();
    const isTextInput =
      tag === 'input' || tag === 'textarea' || active.hasAttribute('contenteditable');

    if (isTextInput) {
      active.blur();
    }
  }
}
